export function installPusher(
    successCallback: CallableFunction,
    failureCallback: CallableFunction
) {
    if (!document) {
        console.warn('[pusher/installPusher] document is not defined')
        return
    }

    if (isPusherInstalled()) {
        return
    }

    const script = document.createElement('script')
    script.id = 'pusher'
    script.src = 'https://js.pusher.com/7.0/pusher.min.js'

    script.onerror = (error) => {
        console.error(error)
        failureCallback()
    }

    script.onload = () => {
        successCallback()
    }

    document.head.append(script)
}

export function isPusherInstalled(): boolean {
    if (!document) {
        console.warn('[pusher/isPusherInstalled] document is not defined')
        return false
    }

    const script = document.head.querySelector('script#pusher')
    return Boolean(script)
}

export default {
    installPusher,
    isPusherInstalled,
}
